// extracted by mini-css-extract-plugin
module.exports = {"darkmodeLabel":"DarkModeSwitch_darkmodeLabel__3FaJz","darkmodeBall":"DarkModeSwitch_darkmodeBall__UUILD","darkmodeCheckbox":"DarkModeSwitch_darkmodeCheckbox__1EWJQ"};